import React, { useEffect, useState } from "react";
import moment from "moment";
import { fetchJson, post } from "../../lib/Fetching";

export default function TodoHistory({ todo, showHistory, showDetails}) {
  const [todoHistory, setTodoHistory] = useState([]);

  const fetchTodoHistory = id =>
    fetchJson("/registration/todos/" + id + "/audit_history").then(json => {
      if (json.error) alert(json.error);
      else setTodoHistory(json);
    });

  useEffect(() => {
    if (showHistory) {
      fetchTodoHistory(todo.id);
    }
  }, [todo, showHistory]);

  return (
    <div style={{ textAlign: "right" }}>
      {showDetails && showHistory && (
        <div data-testid="todoHistory" className="subtext" style={{ color: "#747474", fontSize: 12 }}>
          Author: {todo.author} &nbsp;|&nbsp;{" "}
          {moment(todo.created_at).format("DD/MM/YYYY  h:mm a")}
          <ul style={{ listStyleType: "none", padding: 0 }}>
            {todoHistory.map(history => (
              <li key={history.id}>
                Action by: {history.name} completed: {history.completed ? "Yes" : "No"}{" "}
                &nbsp;|&nbsp; {moment(history.created_at).format("DD/MM/YYYY  h:mm a")}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
